import { setContext } from "@apollo/client/link/context";

import { getTokens } from "./";

export const authLink = setContext((_, { headers }) => {
  const authToken = getTokens().auth;
  return {
    headers: {
      ...headers,
      authorization: authToken ? `Bearer ${authToken}` : ""
    }
  };
});

export default authLink;
